<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <list
          :tournament-view="tournamentView"
          @form="dialog = true"
          @view="view = true"
          @clear="$refs.form.clear()"
        />
        <form-manager
          ref="form"
          :dialog="dialog"
          :tournament="tournament"
          :tournament-view="tournamentView"
          @close="dialog = false"
        />
        <match-view :dialog="view" @close="view = false" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import FormManager from './FormManager'
import List from './List'
import MatchView from './MatchView'
export default {
  name: 'Matches',
  components: {
    List,
    FormManager,
    MatchView,
  },
  props: {
    tournament: {
      type: Object,
      required: false,
      default: null,
    },
    tournamentView: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      view: false,
    }
  },
  mounted() {
    this.resetState()
    if (!this.tournamentView) this.resetTournaments()
    this.initData()
  },
  computed: {
    ...mapState({
      statusOfButton: (state) => state.events.status,
    }),
  },
  methods: {
    ...mapActions({
      fetchTournaments: 'tournaments/fetchSelectList',
      fetchMatches: 'matches/fetchList',
      fetchPitches: 'pitches/fetchSelectList',
      fetchTeamSelect: 'teams/fetchSelectList',
      resetState: 'matches/resetState',
      resetTournaments: 'tournaments/resetState',
      setStatus: 'events/setStatus',
    }),
    async initData() {
      // this.resetPagitations()
      if (!this.tournamentView) {
        this.fetchMatches()
        this.fetchTournaments()
      }

      // await Promise.all([
      //   // this.fetchTeamSelect(),
      //   // this.fetchUserSelect({ typeRole: 'player'}),
      //   // this.fetchPitches({ limit: 0 })
      // ])
    },
  },
  watch: {
    statusOfButton: function (val) {
      if (val) this.initData().finally(() => this.setStatus(false))
    },
  },
}
</script>
